import React from 'react';
import Headers from './Headers/Headers';
import Example from './info/info';

function App (props) {
  return (
    <div>
    <Headers />
    <Example />
    </div>
  );
};
export default App;